@if (enabled) {
  <button class="fixed bottom-4 right-4 z-50 bg-surface-200 rounded-full p-2 opacity-80 hover:opacity-100"
          (click)="dialogOpen.set(true)">
    <i class="pi pi-wrench text-sm"></i>
  </button>
  <p-dialog header="Debug" [(visible)]="dialogOpen" [modal]="true" [closable]="true" styleClass="max-w-sm"
            [style]="{ 'max-height': '80vh' }" [contentStyle]="{ 'overflow-y': 'auto' }">
    <div class="flex flex-col gap-4">
      <h3 class="font-semibold text-sm">Payment</h3>
      <div class="flex items-center justify-between gap-4">
        <label class="text-sm">Free trial unavailable</label>
        <p-toggleswitch [ngModel]="paymentService.appFreeTrialUnavailable()"
                        (ngModelChange)="paymentService.appFreeTrialUnavailable.set($event)"/>
      </div>

      <h3 class="font-semibold text-sm mt-2">Benefits page style override</h3>
      <p-select-button [options]="styleOptions" [allowEmpty]="true" styleClass="text-xs flex-wrap"
                       [ngModel]="debugService.benefitsPageStyleOverride()"
                       (ngModelChange)="debugService.benefitsPageStyleOverride.set($event)"
                       optionLabel="label" optionValue="value"/>
      <p class="text-xs text-muted-color">Leave unselected for automatic</p>

      <h3 class="font-semibold text-sm mt-2">A/B Variables</h3>
      @for (v of abService.basicVariables; track v.name) {
        <div>
          <label class="text-xs text-muted-color block mb-1">{{ v.name }}: {{ v.signal() }}</label>
          <p-select-button [options]="$any(v.options)" [allowEmpty]="false" styleClass="text-xs flex-wrap"
                           [ngModel]="v.signal()"
                           (ngModelChange)="v.signal.set($event)"/>
        </div>
      }

      <h3 class="font-semibold text-sm mt-2">JSON A/B Variables</h3>
      @for (v of abService.jsonVariables; track v.name) {
        @let state = getJsonEditorState(v.name, v.signal());
        <div>
          <label class="text-xs text-muted-color block mb-1">{{ v.name }}</label>
          <textarea pTextarea [rows]="4" class="w-full text-xs font-mono"
                    [ngModel]="state().text"
                    [ngClass]="{'border-red-500': state().error}"
                    (ngModelChange)="state.set({text: $event, error: ''})"></textarea>
          @if (state().error) {
            <p class="text-xs text-red-500 mt-1">{{ state().error }}</p>
          }
          <div class="flex gap-2 mt-1">
            <button pButton severity="primary" class="text-xs" size="small" (click)="applyJsonVariable(v)"><span pButtonLabel>Apply</span></button>
            <button pButton severity="secondary" class="text-xs" size="small" (click)="resetJsonVariable(v)"><span pButtonLabel>Reset</span></button>
          </div>
        </div>
      }

      <h3 class="font-semibold text-sm mt-2">Storage</h3>
      <button pButton severity="danger" class="text-sm" (click)="clearStorage()"><span pButtonLabel>Clear all storage</span></button>
    </div>
  </p-dialog>
}
